import cn from "classnames";
import React, { useState } from "react";
import { Popover as TinyPopover } from "react-tiny-popover";

export default function Popover(props) {
    const [opened, setOpened] = useState(props.opened);

    const openDropd = () => {
        setOpened(true);
        props.onOpen?.();
    };

    const closeDropd = () => {
        setOpened(false);
        props.onClose?.();
    };

    const renderBody = () => {
        const contentCnames = cn("dropdown__content", {
            [contentCname]: !!contentCname,
        });
        return (
            <div className={contentCnames} onClick={() => closeDropd()}>
                {props.children}
            </div>
        );
    };

    const { text, cname, withoutChevron, wrapCname, contentCname, name, positions } = props;
    const chevronCname = cn("dropdown__btn-chevron", {
        "dropdown__btn-chevron--top": positions?.[0] === "top" ? !opened : opened,
        "dropdown__btn-chevron--bottom": positions?.[0] === "top" ? opened : !opened,
    });

    return (
        <div className={cn("dropdown", { [wrapCname]: !!wrapCname })}>
            <TinyPopover
                isOpen={opened}
                align={props.align ?? "start"}
                onClickOutside={closeDropd}
                positions={props.positions ?? ["bottom", "top", "left", "right"]}
                content={renderBody()}
            >
                <div
                    className={cname || "dropdown__btn"}
                    onClick={() => (opened ? closeDropd() : openDropd())}
                    data-test-id={name}
                >
                    {text}
                    {!withoutChevron && <div className={chevronCname} />}
                </div>
            </TinyPopover>
        </div>
    );
}
